import axios from 'axios';

const TIMEOUT = 30000;

const CONFIG = {
    country: 'de',
    brand: process.env.REACT_APP_BRAND,
    product: 'privatelease',
};

const MAX_FILE_COUNT = 3;

function readAsync(fileHandle) {

    return new Promise((resolve, reject) => {

        const fileReader = new FileReader();

        fileReader.onload = () => {
            const r = fileReader.result;
            resolve(r.substr(r.indexOf(',') + 1));
        };

        fileReader.onerror = (e) => {
            reject(new Error('Read failed'));
        };

        fileReader.readAsDataURL(fileHandle);
    });
}

async function uploadAsync({file, transactionId, onUploadProgress}) {

    const {data, status} = await axios({
        method: 'post',
        url: process.env.REACT_APP_DOCUMENT_UPLOAD_URL,
        headers: {
            'Cache-Control': 'no-cache, no-store',
            Pragma: 'no-cache',
        },
        data: {
            ...CONFIG,
            transactionId,
            file,
        },
        timeout: TIMEOUT,
        onUploadProgress,
        validateStatus: status => [200, 400].includes(status),
    });

    return {
        id: status === 200 ? data.file?.id : undefined,
        status
    };
}

async function deleteAsync({fileId, transactionId}) {

    const {data: {id}} = await axios({
        method: 'delete',
        url: process.env.REACT_APP_DOCUMENT_DELETE_URL,
        headers: {
            'Cache-Control': 'no-cache, no-store',
            Pragma: 'no-cache',
        },
        timeout: TIMEOUT,
        data: {
            ...CONFIG,
            transactionId,
            fileId,
        },
    });

    if (fileId !== id) {
        throw new Error(
            `Got wrong id for file deletion! Expected '${id}' to be '${fileId}'`,
        );
    }

    return id;
}

export {readAsync, deleteAsync, uploadAsync, MAX_FILE_COUNT};
